import {
  Formik,
  Mutation,
  React,
  SubmitAndReset,
  TextArea,
  TextInput,
  Yup,
} from '@1337lawyers/design';

import * as CREATE_VERIFICATION_METHOD from './createVerificationMethod.gql';

interface ICreateVerificationMethodValues {
  name: string;
  description: string;
}

export const CreateVerificationMethod = () => (
  <Mutation mutation={CREATE_VERIFICATION_METHOD}>
    {(createVerificationMethod, { data }) => (
      <Formik
        initialValues={{
          name: '',
          description: '',
        }}
        onSubmit={async (
          values: ICreateVerificationMethodValues,
          { setSubmitting }
        ) => {
          setSubmitting(true);
          await createVerificationMethod({
            variables: { ...values },
          }).catch(() => {
            setSubmitting(false);
          });
          console.log(data);
          setSubmitting(false);
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required(),
          description: Yup.string().required(),
        })}
        render={({
          values,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          errors,
          handleReset,
        }) => (
          <form onSubmit={handleSubmit}>
            <TextInput
              touched={touched}
              errors={errors}
              values={values}
              label="Name"
              handleBlur={handleBlur}
              handleChange={handleChange}
              value="name"
            />

            <TextArea
              touched={touched}
              errors={errors}
              values={values}
              label="Description"
              handleBlur={handleBlur}
              handleChange={handleChange}
              value="description"
            />

            <SubmitAndReset
              errors={errors}
              isSubmitting={isSubmitting}
              submitButtonText="Create Verification Method"
              handleReset={handleReset}
            />
          </form>
        )}
      />
    )}
  </Mutation>
);
